module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/candidates/candidates.component.css
// module id = ./src/app/candidates/candidates.component.css
// module chunks = main